import Control from './Control';
export default class ProgressControl extends Control {
    constructor(field) {
        super(field);
    }
    render() {
        return `<div class=progress id="${this.field.internalId}_progress"><span class=percentage></span><span class=percentage-text>0%</span></div>`;
    }
    initHTMLElements() {
        if (this.htmlElements)
            return;
        const id = `${this.field.internalId}_progress`;
        this.htmlElements = {
            container: document.getElementById(id),
            percentage: document.querySelector(`[id="${id}"] .percentage`),
            percentageText: document.querySelector(`[id="${id}"] .percentage-text`)
        };
    }
    show() {
        this.initHTMLElements();
        this.htmlElements.container.classList.add('visible');
    }
    hide() {
        this.htmlElements.container.classList.remove('visible');
    }
    update(percent) {
        this.htmlElements.percentage.style.width = `${percent}%`;
        this.htmlElements.percentageText.innerHTML = `${Math.round(percent)}%`;
    }
}
